var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-3"},[_c('div',{class:`${_vm.headerClass}
      text-center
      py-2
      w-100
      font-weight-bold
      fs_16
      rounded-top`,domProps:{"textContent":_vm._s(_vm.title)}}),_c('b-table',{class:`text-center table-${_vm.variant} mb-0`,attrs:{"striped":"","responsive":"","show-empty":"","empty-text":_vm.$lang.notRecordExist,"fields":_vm.fields,"items":_vm.items}}),(_vm.hasFooter)?_c('div',{class:`${_vm.footerClass}
      text-center
      py-2
      w-100
      font-weight-bold
      fs_16
      rounded-bottom`},[_vm._t("footer")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }